import axios from 'axios'

import {
  Customer,
  FetchCustomerProps,
  UpdateCustomerProps,
  UpdateCustomerResponse,
} from '../model/customer.model'

import { getToken } from '~/net/'

export default class CustomerService {
  constructor(private apiGateway: string) {}

  fetchCustomer(fetchCustomerProps: FetchCustomerProps): Promise<Customer> {
    const { documentType, document, brand, sub } = fetchCustomerProps
    const body = {
      documentType,
      document,
    }
    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token?.access_token}` }
        }

        return axios.post<Customer>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/customers/search`,
          body,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'cache-control': 'no-cache',
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => resp.data)
  }

  updateCustomer(updateCustomerProps: UpdateCustomerProps): Promise<UpdateCustomerResponse> {
    const { customerId, email, brand, sub } = updateCustomerProps

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token?.access_token}` }
        }

        return axios.post<UpdateCustomerResponse>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/customers/${customerId}`,
          {
            personal: { email },
          },
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => resp.data)
  }
}
